const BLOCK_TAGS = [
  "TABLE",
  "THEAD",
  "TBODY",
  "TFOOT",
  "TR",
  "TD",
  "TH",
  "CAPTION",
  "UL",
  "OL",
  "LI",
  "DL",
  "DT",
  "DD",
  "FIELDSET",
  "LEGEND",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HR",
  "BLOCKQUOTE",
  "PRE",
  "FORM",
  "SECTION",
  "ARTICLE",
  "HEADER",
  "FOOTER",
  "NAV",
  "MAIN",
  "ASIDE",
  "P",
  "DIV",
];

const UNSAFE_TAGS = [
  "script",
  "noscript",
  "style",
  "link",
  "meta",
  "base",
  "template",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "portal",
  "svg",
  "math",
  "form",
  "input",
  "button",
  "select",
  "option",
  "textarea",
];

const UNWRAP_TAGS = [
  "b",
  "strong",
  "i",
  "em",
  "u",
  "s",
  "strike",
  "del",
  "ins",
  "mark",
  "small",
  "big",
  "font",
  "sub",
  "sup",
  "tt",
  "center",
  "abbr",
  "cite",
  "label",
];

const SPACED_UNWRAP_TAGS = ["CENTER"];

const ALLOWED_ATTR = ["colspan", "rowspan", "href", "src", "alt"];

const SANITIZE_CONFIG = {
  FORBID_TAGS: [...UNSAFE_TAGS, ...UNWRAP_TAGS],
  ALLOWED_ATTR,
  ALLOW_DATA_ATTR: false,
  ALLOW_ARIA_ATTR: false,
  KEEP_CONTENT: true,
};

const LIST_TAGS = ["UL", "OL"];

const TABLE_TAGS = ["TABLE", "THEAD", "TBODY", "TFOOT", "TR"];

const NUMERIC_ATTRS: Record<string, string> = { colspan: "colSpan", rowspan: "rowSpan" };

const COLUMN_CLASS = "flex gap-1 flex-col";

const STYLABLE_TAGS = [
  "div",
  "p",
  "span",
  "a",
  "img",
  "hr",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "fieldset",
  "legend",
  "blockquote",
  "pre",
  "code",
  "q",
  "dl",
  "dt",
  "dd",
  "figure",
  "figcaption",
  "section",
  "article",
  "header",
  "footer",
  "nav",
  "main",
  "aside",
  "form",
  "input",
  "button",
  "details",
  "summary",
] as const;

const KNOWN_STYLE_OPTIONS = [
  "columnStyles",
  "pieceStyles",
  "tableStyles",
  "rowStyles",
  "cellStyles",
  "thStyles",
  "tdStyles",
  "listStyles",
  "ulStyles",
  "olStyles",
  "listLabelStyles",
  "liStyles",
  "liLabelStyles",
  "pairStyles",
  "pairLabelStyles",
  "pairValueStyles",
  ...STYLABLE_TAGS.map((tag) => `${tag}Styles`),
];

export {
  BLOCK_TAGS,
  SANITIZE_CONFIG,
  SPACED_UNWRAP_TAGS,
  LIST_TAGS,
  TABLE_TAGS,
  NUMERIC_ATTRS,
  COLUMN_CLASS,
  STYLABLE_TAGS,
  KNOWN_STYLE_OPTIONS,
};
